import {SquadflixCollection} from "../../app/myProfileView/my-profile-subroutes/my-profile-lists/types";
import './squadflix-collection-card.scss';
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import users from "../../users";
import {cn} from "../../../utils/utils";
import TmdbImage from "../tmdb-image/tmdb-image";

type Props = {
    collection: SquadflixCollection
}

const SquadflixCollectionCard = ({collection}: Props) => {

    const darkMode = useSelector(users.selectors.isDarkMode)

    return (
        <Link to={collection.id + ""}
              className={cn("squadflix-collection-card", {"squadflix-collection-card--dark": darkMode})}>
            <div className="squadflix-collection-card-info">
                <div className="squadflix-collection-card-info-name">{collection.name}
                    {collection.private && <i className="fa-solid fa-lock fa-xs ps-2"></i>}</div>
                <div className="squadflix-collection-card-info-items-count">{collection.totalItems} cosas</div>
            </div>
            <div className="squadflix-collection-card-items-preview" style={{
                gridTemplateColumns: `repeat(${collection.items.length}, 1fr)`,
            }}>
                {collection.items.map((item, i) => (
                    <TmdbImage
                        key={item.tmdbId + "_" + item.isMovie.valueOf()}
                        src={item.item.poster_path}
                        size="w500"
                        alt={item.item.title ?? item.item.name}
                    />
                ))
                }
            </div>
        </Link>
    )

}

export default SquadflixCollectionCard;
